import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "image-finetune__bottom" }

import { PropType, ref, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { PinturaEditor } from '@pqina/vue-pintura';
import { getEditorDefaults } from '@pqina/pintura';

import { useCommonStore } from '@/store/common';

import { fileToDataURL } from '@/helpers/fileToDataURL';

import AiButton from '@/components/UI/AiButton/AiButton.vue';

import localeRu from '@/assets/pintura/ru.json';


export default /*@__PURE__*/_defineComponent({
  __name: 'ImageFinetune',
  props: {
  actions: {
    type: Array as PropType<string[]>,
    default: () => ['reset', 'back', 'save'],
  },
  src: {
    type: String as PropType<string>,
    required: true,
  },
},
  emits: ['save', 'reset', 'back'],
  setup(__props, { emit: __emit }) {

const { isMobile } = storeToRefs(useCommonStore());

const pinturaEditorRef = ref<any | null>(null);
const editorProps = ref(getEditorDefaults());

const props = __props;

const emits = __emit;

const resetHandler = (): void => {
  emits('reset');
};

const backHandler = (): void => {
  emits('back');
};

const editHandler = (): void => {
  pinturaEditorRef.value.editor.processImage().then(async (res: any) => {
    const imageData = await fileToDataURL(res.dest);
    emits('save', imageData);
  });
};

onMounted(async () => {
  editorProps.value = { ...getEditorDefaults(), locale: { ...getEditorDefaults().locale, ...localeRu } };
});

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["image-finetune", {'image-finetune--mobile': _unref(isMobile) }])
  }, [
    _createVNode(_unref(PinturaEditor), _mergeProps(editorProps.value, {
      src: props.src,
      utils: ['finetune'],
      enableButtonClose: false,
      enableButtonExport: false,
      enableButtonRevert: false,
      previewUpscale: true,
      ref_key: "pinturaEditorRef",
      ref: pinturaEditorRef
    }), null, 16, ["src"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_spacer),
      (props.actions.indexOf('reset') !== -1)
        ? (_openBlock(), _createBlock(AiButton, {
            key: 0,
            theme: "dark",
            onClick: resetHandler
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('services.reset')), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (props.actions.indexOf('back') !== -1)
        ? (_openBlock(), _createBlock(AiButton, {
            key: 1,
            theme: "dark",
            onClick: backHandler
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.back')), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (props.actions.indexOf('save') !== -1)
        ? (_openBlock(), _createBlock(AiButton, {
            key: 2,
            theme: "gradient",
            onClick: editHandler
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('profile.save')), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})